<template>
  <div id="print" class="body-wrap">
    <div class="bgc">
      <h1>
        凝血功能異常評估表<br /><span style="font-size: 30px"
          >感謝您，填寫凝血功能異常評估表！</span
        >
      </h1>
    </div>
    <div class="container">
      <div class="row">
        <div class="col-12 col-md-12">
          <div class="b">
            <h2 class="center-1">
              <span style="color: #318acc">以下為您的評估表結果</span>
            </h2>
            <h2
              class="center-1"
              v-for="i in this.information"
              :key="i.information_id"
            >
              <span style="color: #318acc"
                >您的{{ i.question }}：{{ i.answer }}</span
              >
            </h2>
            <h2 class="center-1">
              <span style="color: #318acc; margin-bottom: 0"
                >您的凝血功能分數：{{ this.conclusion.score }}</span
              >
            </h2>

            <div class="img-box" v-if="!this.passed">
              <img :src="'/assets/img/261-01.jpg'" />
              <h2 class="center-2">凝血功能可能異常</h2>
            </div>

            <div class="img-box" v-if="this.passed">
              <img :src="'/assets/img/907-01.jpg'" />
              <h2 class="center-2">
                <span style="color: rgba(0, 192, 0, 0.644)">凝血功能正常</span>
              </h2>
            </div>
          </div>
          <div class="b">
            <h2 class="center-1 h2">
              成人男性分數總和若≥4分，<br />
              成人女性分數總和若≥6分， <br />
              兒童分數總和若≥3分， <br />
              則有患病風險，請前往醫院諮詢血液科醫師。
            </h2>
          </div>
        </div>
      </div>
    </div>
    <div class="table">
      <div class="pin"></div>
      <table>
        <thead>
          <tr>
            <td class="col" style="width: 60%">問題</td>
            <td class="col" style="width: 40%">您的答案</td>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(q, index) in this.result" :key="q.question_id">
            <td>{{ index + 1 }}、{{ q.question }}</td>
            <td>{{ q.answer }}</td>
          </tr>
        </tbody>
      </table>
      <div class="container">
        <div class="col-12 col-md-12">
          <div class="button">
            <button id="next">
              <a target="_blank" :href="this.download_url" style="color: white"> 下載評估表 </a>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <p></p>
      <h2 class="center-3 h2" style="text-align: justify">
        參考資料：<br />ISTH/SSC bleeding assessment tool: a standardized
        questionnaire and a proposal for a new bleeding score for inherited
        bleeding disorders.Rodeghiero F, Tosetto A, Abshire T, Arnold DM, Coller
        B, James P, Neunert C, Lillicrap D; ISTH/SSC joint VWF and
        Perinatal/Pediatric Hemostasis Subcommittees Working Group. J Thromb
        Haemost. 2010 Sep;8(9):2063-5
      </h2>
    </div>
  </div>
</template>

<script>
import { apiGet as apiGetResult } from "@f/api/form_survey/get_result.js";
import { apiGet as apiGetResultInformation } from "@f/api/form_survey/get_result_information.js";
import { apiGet as apiGetURL } from "@f/api/form_survey/get_url.js";

// import axios from "axios";
// Vue.use(axios);

const baseURL = "https://api.coindesk.com/v1/bpi/currentprice.json";

export default {
  data: function () {
    return {
      result_uuid: "028e3054-8292-458d-ab62-225bbc2c8804",
      result: {},
      information: {},
      conclusion: {
        score: 0,
        gender: "",
        age: "",
      },
      json_result: {
        answer: {},
        information: {},
        score: 0,
        passed: 0,
        picture: "",
        text: "",
        url: "",
      },
      passed: false,
      download_url: "",
    };
  },
  created() {
    this.init();
  },
  methods: {
    // Init
    async init() {
      this.swalProccess("頁面加載中");
      try {
        let queryString = decodeURIComponent(window.location.search);
        let params = new URLSearchParams(queryString);
        this.result_uuid = params.get("result_uuid");
        this.getResult(this.result_uuid);
        this.swalClose();
      } catch (err) {
        console.log("Init Error");
        console.log(err);
      }
    },

    // Get Result and Result Information
    async getResult(result_uuid) {
      let query = "result_uuid=" + result_uuid;
      await apiGetResult(query)
        .then((res) => {
          if (res.data.code === 200) {
            let result = [];
            let json_answer = [];
            res.data.data.forEach(function (d) {
              result.push({
                question_id: d.question_id,
                question: d.question,
                answer: d.answer,
                score: d.score,
              });

              json_answer.push(
                d.answer,
              );
            });

            this.result = result;
            this.json_result.answer = json_answer;

            let total_score = 0;
            this.result.forEach(function (d) {
              total_score += d.score;
            });
            this.conclusion.score = total_score;
            this.json_result.score = this.conclusion.score;

            this.getResultInformation(result_uuid);
          } else {
            this.swalError();
            console.log("Get QNA Error I");
          }
        })
        .catch((err) => {
          console.log("Get QNA Error II");
          console.log(err);
        });
    },
    async getResultInformation(result_uuid) {
      let query = "result_uuid=" + result_uuid;
      await apiGetResultInformation(query)
        .then((res) => {
          if (res.data.code === 200) {
            let information = [];
            let json_information = [];
            res.data.data.forEach(function (d) {
              information.push({
                information_id: d.question_id,
                question: d.question,
                answer: d.answer,
              });

              json_information.push(
                d.answer,
              );
            });

            this.information = information;
            this.conclusion.gender = this.information[0].answer;
            this.conclusion.age = this.information[1].answer;
            this.json_result.information = json_information;

            this.json_result.url =
              "survey/thank-you?result_uuid=" + result_uuid;
            
            this.conclude(this.conclusion);
            this.getURL(this.json_result);
          } else {
            this.swalError();
            console.log("Get Result Information Error I");
          }
        })
        .catch((err) => {
          console.log("Get Result Information Error II");
          console.log(err);
        });
    }, 
    async getURL(json_result) {
      let query = "json_result=" + JSON.stringify(json_result);
      await apiGetURL(query)
        .then((res) => {
          if (res.data.code === 200) {
            let download_url = "";
            download_url = res.data.data.data.pdf;
            this.download_url = download_url;
          } else {
            this.swalError();
            console.log("Get URL Error I");
          } 
        })
        .catch((err) => {
          console.log("Get URL Error II");
          console.log(err);
        });
    },
    conclude(conclusion) {
      if (conclusion.age == "18歲以下") {
        if (conclusion.score >= 3) {
          this.passed = false;
        } else {
          this.passed = true;
        }
      } else {
        if (conclusion.gender == "男") {
          if (conclusion.score >= 4) {
            this.passed = false;
          } else {
            this.passed = true;
          }
        } else if (conclusion.gender == "女") {
          if (conclusion.score >= 6) {
            this.passed = false;
          } else {
            this.passed = true;
          }
        }
      }

      this.json_result.passed = this.passed;

      if (this.passed == false) {
        this.json_result.picture = "261-01.jpg";
        this.json_result.text = '<h2 class="center-2">凝血功能可能異常</h2>';
      } else {
        this.json_result.picture = "907-01.jpg";
        this.json_result.text =
          '<h2 class="center-2"><span style="color: rgba(0, 192, 0, 0.644)">凝血功能正常</span></h2>';
      }
    },

    // Download PDF
    // async download() {
    //   try {
    //     const res = await axios.get(baseURL);
    //     this.url_link = res.data;

    //     console.log(this.url_link);

    //     // const res = await axios.post(baseURL, {name: this.url_link});
    //   } catch (e) {
    //     console.log(e);
    //   }

    // const doc = new jsPDF({
    //   orientation: "portrait",
    //   unit: "in",
    //   format: "letter",
    // });

    // doc.html("Hellow World", {
    //   x: 10,
    //   y: 10,
    // });
    // const doc = new jsPDF();

    // doc.text("凝血功能異常評估表", 10, 10);
    // doc.text("感謝您，填寫凝血功能異常評估表！", 10, 10);
    // doc.save("Survey Result.pdf");
    //   // window.print('Survey Result.pdf');
    // },
  },
};
</script>

<style scoped>
button {
  text-align: center;
  background-color: #48aad7;
  border-radius: 20px;
  width: 200px;
  margin: 0 auto;
  color: white;
  text-decoration: none;
  display: block;
  font-size: 30px;
}

button:hover {
  background-color: #0088c783;
}

.pin {
  width: 90px;
  height: 90px;
  /* background-color: wheat; */
  margin: 0 auto;
  position: absolute;
  left: 55%;
  top: 10px;
  transform: translateX(-55%);
  z-index: 1;
}
#Capa_1 {
  fill: #0077aa;
}
.center {
  text-align: center;
  margin-top: 20px;
}
.center-1 {
  text-align: center;
  font-size: 25px;
}
.center-2 {
  text-align: center;
  color: red;
  font-size: 30px;
}
.b {
  margin-top: 30px;
}
.img-box {
  margin-top: 10px;
  width: 250px;
  height: 250px;
  margin: 0 auto;
}
.img-box img {
  width: 100%;
}
/* h1{
    font-size: 34px;
    background-color: rgba(226, 226, 226, 0.61);
    display: block;
    width: 250px;
    border:solid 1px black;
    border-radius: 50px;
    margin: auto;
    letter-spacing: 2px;
} */
.table {
  width: 80%;
  /* background-color: white; */
  margin: auto;
  text-align: left;
  padding-top: 50px;
}
table {
  width: 100%;
  background-color: rgba(255, 255, 255, 0.904);
  padding: 100px;
  margin: 0 auto;
  margin-bottom: 30px;
  font-size: 0;
  box-shadow: 2px 2px 5px #aaa;
}
.col {
  background-color: #318acc;
  text-align: center;
  font-weight: 600;
  color: white;
}
.col-1 {
  margin: 0 auto;
}
.col-1 a {
  text-align: center;
  background-color: #48aad7;
  border-radius: 20px;
  width: 200px;
  margin: 0 auto;
  color: white;
  text-decoration: none;
  display: block;
  font-size: 30px;
}
.col-1:hover a {
  background-color: #48aad7cc;
}
.table td {
  border: solid 1px black;
  /* background-color: white; */
  padding: 11px;
  font-size: 16pt;
  font-weight: bold;
  vertical-align: middle;
}
.table tbody tr:nth-child(even) {
  background-color: #bcd9e84f !important;
}
.footer {
  width: 100%;
  margin: 0 auto;
}
.footer p {
  width: 960px;
  margin: 0 auto;

  margin-top: 40px;
  margin-bottom: 40px;
  font-size: 11pt;
}
.bgc {
  width: 100%;
  height: 300px;
  background-image: url("/assets/img/395.jpg");
  display: flex;
  justify-content: center;
  align-items: center;
}
.bgc h1 {
  color: white;
  text-align: center;
  text-shadow: 1px 2px 6px #191818;
  font-weight: bold;
  font-size: 48px;
}
h2 {
  text-align: center;
}
.center {
  font-size: 23px;
  line-height: 3;
}
.center-1 {
  width: 390px;
  margin: 0 auto;
  text-align: center;
}
.h2 {
  margin-bottom: 50px;
  font-size: 17px;
}
.center-3 {
  width: 920px;
  height: 300px;
  margin: 0 auto;
  text-align: left;
  font-weight: normal;
}

/* ------------------------------------ */

@media screen and (max-width: 767px) {
  .question {
    font-size: 22px;
  }
  .bgc h1 {
    font-size: 30px;
    padding: 22px;
  }
  .bgc {
    background-attachment: scroll;
  }
  .quiz-container {
    height: 520px;
  }
  .button {
    margin-top: 75px;
  }
  .n {
    margin-bottom: 250px !important;
  }
}

@media screen and (max-width: 320px) {
  .pn {
    padding-right: 0px !important;
    padding-left: 0px !important;
  }
  .quiz-container {
    height: 570px;
  }
  .bgc h1 {
    font-size: 30px;
    padding: 22px;
  }
}
</style>
  